<template lang="pug">
.page(v-if="board")
  section
    .max-width
      .breadcrumbs(v-if="isApp")
        ul
          li
            router-link.primary-link(
              :to="{ name: isAdmin ? 'AdminDashboard' : 'PublicDashboard' }"
            ) Dashboard
          li
            span \
          li.selected
            span {{ board.name }}

  section
    .max-width
      .row
        .col.max
          header.board-header
            .tabs
              .row.apart
                .col
                  .tab.active
                    h2 {{ board.name }}
                .col(v-if="isAdmin && company.isMember")
                  .page-actions
                    router-link.button(
                      :to="{ name: 'BoardSettingsGeneral', params: { boardSlug: board.slug } }"
                    ) Settings

          div
            .filter(v-if="!noRequests")
              span Showing
              DropdownMenu(align="center")
                template(slot="toggle")
                  .active
                    span {{ filters.active }}
                    font-awesome-icon.active-filter-icon(
                      :icon="['fas', 'angle-down']"
                    )
                template(slot="menu")
                  .row
                    .col
                      .list-menu
                        .list-item(@click="filter()") Trending
                        .list-item(@click="filter('recent')") Recent
                        .list-item(
                          @click="filter('owner')",
                          v-if="user.isAuthenticated"
                        ) My Own
                        .list-item(
                          v-if="company.isMember",
                          @click="filter('assigned')"
                        ) Assigned
                        .list-item(@click="filter('liked')") Liked
                    .col
                      .list-menu
                        .list-item(
                          v-for="status in statuses",
                          @click="filterStatus(status)"
                        ) {{ status.label }}
              span Posts

            .features
              router-link(
                v-for="feature in features",
                :to="{ name: routeName, params: { boardSlug: board.slug, featureSlug: feature.slug } }",
                :key="feature._id"
              )
                BoardFeature(:feature="feature")
          .empty-placeholder.sub-section(v-if="noResults")
            //-font-awesome-icon.icon(:icon="['fad', 'sad-tear']")
            .animation
              LottieAnimation(svg="search", :width="200", :height="200")
            p We like to think we are magicians but what you are looking for was not found.<br/>Try a new search or create a new request.
          .empty-placeholder.sub-section(v-if="noRequests")
            font-awesome-icon.icon(:icon="['fad', 'sad-tear']")
            p No requests yet. You could be the first!
        .col.sidebar
          aside(:class="{ 'bump-down': !isApp }")
            .search
              form(@submit.prevent)
                .form-field.no-margin
                  label
                    input.large(
                      type="text",
                      placeholder="Search Ideas",
                      v-debounce="filter",
                      v-model="filters.text"
                    )
            .post
              .post-header
                h2.primary-text Create a New Idea
                p {{ board.description }}
              form(@submit.prevent="submit")
                .form-field
                  label
                    input(
                      v-model="$v.form.name.$model",
                      type="text",
                      placeholder="Title",
                      maxlength="150"
                    )
                    .error(
                      v-if="$v.form.name.$error && !$v.form.name.required"
                    ) Field is required
                .form-field
                  label
                    textarea(
                      v-model="$v.form.description.$model",
                      placeholder="Description",
                      maxlength="2500"
                    )
                    .error(
                      v-if="$v.form.description.$error && !$v.form.description.required"
                    ) Field is required
                //-div.form-field(v-if="form.attachments")
                  .attachment(v-for="attachment in form.attachments")
                    img(:src="attachment.url")
                .form-field
                  form-upload(
                    @uploaded="uploaded",
                    endpoint="attachment",
                    size="full"
                  )
                    button.button.upload(type="button")
                      .form-field-upload
                        .empty(v-if="!form.attachments")
                          span Add Image (Optional)
                          font-awesome-icon(
                            :icon="['fad', 'image']",
                            style="--fa-primary-color: #00AC97;--fa-secondary-color: #00AC97;"
                          )
                        .uploaded(v-else)
                          .attachment(v-for="attachment in form.attachments")
                            div
                              span {{ attachment.fileName }}
                            img(:src="attachment.url")

                .form-field
                  .col
                    button.button.primary-button(type="submit") Create
</template>

<script>

/*{
    "filter": {
        "board": [ board._id ],
        "assignedTo": [ user._id ],
        "creator": [ user._id ],
        "status": [ status._id ]
        "isCommented": Bool,
        "isLiked": Bool
    },
    sort: {
        prop: "created|updated|popular" <- default (updated)
        dir: "ascending|descending" <- default (desc)
    }
}*/

import LottieAnimation from '@/components/helpers/LottieAnimation'


import { required } from 'vuelidate/lib/validators'
import { mapState, mapGetters } from 'vuex'

import FormUpload from '@/components/form/FormUpload'
import BoardFeature from '@/components/BoardFeature'

const defaultFilter = {
  active: 'Trending',
  text: '',
  filter: {
  },
  sort: {},
  boardSlug: null
}


export default {
  name: 'ViewBoard',
  components: {
    FormUpload,
    BoardFeature,
    LottieAnimation
  },
  props: {
    app: {
      type: Boolean,
      default: true
    }
  },
  beforeMount () {
    this.filters.boardSlug = this.$route.params.boardSlug

    this.$store.commit('boards/SELECT_BOARD', this.$route.params.boardSlug)
    //console.log(this.board)
    //this.$store.dispatch()

    let filters = this.$store.state.features.filters
    if (filters && filters.boardSlug === this.$route.params.boardSlug) {
      console.log('setting filters', filters)
      this.filters = filters

      this.$store.dispatch('features/searchFeatures', {
        filter: this.filters.filter,
        sort: this.filters.sort
      })

    } else {
      this.$store.dispatch('features/getFeatures')

    }
  },
  mounted () {
    //console.log('board mounted')
  },
  data () {
    return {
      form: {
        name: '',
        description: '',
        attachments: null
      },
      filters: JSON.parse(JSON.stringify(defaultFilter)),
      hasFilters: false
    }
  },
  validations: {
    form: {
      name: {
        required
      },
      description: {
        required
      }
    }
  },
  computed: {
    ...mapGetters({
      board: 'boards/selected',
    }),
    ...mapState({
      user: state => state.user,
      company: state => state.company,
      features: state => state.features.list,
      statuses: state => state.statuses
    }),
    noResults () {
      return this.hasFilters && this.features.length === 0
    },
    noRequests () {
      return !this.hasFilters && this.features.length === 0
    },
    routeName () {
      return this.$route.meta.member ? 'AdminFeature' : 'PublicFeature'
    },
    isAdmin () {
      return this.$route.matched[0].meta.member
    },
    isApp () {
      //console.log(this.$route)
      return !(this.$route.meta && this.$route.meta.widget)
    }
  },
  methods: {
    uploaded (attachments) {
      this.$set(this.form, 'attachments', [attachments])
    },
    submit (e) {

      /*if (e.key === 'Enter') {
        console.log(e)
        return
      }*/

      this.$v.$touch()
      if (this.$v.$invalid) {
        console.log('invalid')
      } else {

        let data = Object.assign({},
          this.form,
          {
            board: this.board._id
          }
        )
        if (data.attachments) {
          data.attachments = data.attachments.map(attachment => attachment._id)
        }

        this.$store.dispatch('features/postFeature', data).then(() => {
          //this.$toast.open('Post Added');

          this.$set(this, 'filters', defaultFilter)
          this.filters.boardSlug = this.$route.params.boardSlug

          //this.$store.dispatch('features/getFeatures')
          this.$v.$reset()
          this.form = {
            name: '',
            description: '',
            attachments: null
          }

        }, error => {
          //this.error = error
          //console.log(error)
        })
      }
    },
    filter (selected) {
      this.hasFilters = true
      let filter = {
        text: this.filters.text,
        board: [ this.board._id ]
      }
      let sort = {}
      if (selected === 'owner') {
        filter.creator = [ this.user._id ]
        this.filters.active = 'My Own'
      } else if (selected === 'liked') {
        filter.isLiked = true
        this.filters.active = 'Liked'
      } else if (selected === 'assigned') {
        filter.assignedTo = [ this.user._id ]
        this.filters.active = 'Assigned'
      } else if (selected === 'recent') {
        sort.prop = 'created'
        this.filters.active = 'Recent'
      } else {
        sort.prop = 'popular'
        this.filters.active = 'Trending'
      }

      this.filters.filter = filter
      this.filters.sort = sort

      this.$store.dispatch('features/searchFeatures', { filter, sort })
      this.$store.commit('features/SET_FILTERS', this.filters)
    },
    filterStatus (status) {
      this.hasFilters = true
      let filter = {
        text: '',
        board: [ this.board._id ],
        status: [ status._id ]
      }
      this.filters.active = status.label

      this.filters.filter = filter

      this.$store.dispatch('features/searchFeatures', { filter })
      this.$store.commit('features/SET_FILTERS', this.filters)
    },
    filterSearch () {

    }
  }
}
</script>

<style lang="stylus" scoped>
header.board-header
  margin-bottom $spacing-2
  +for_breakpoint(mobile)
    display none

.filter
  font-size 18px
  padding $spacing-2 0 $spacing-4 0
  +for_breakpoint(mobile)
    padding-bottom $spacing-2

  .active
    border-bottom 1px dashed $text-default
    cursor pointer
    display inline-block
    padding 0
    margin 0 $spacing
    span
      margin-right $spacing

    .active-filter-icon
      height 18px
      vertical-align middle

+for_breakpoint(mobile)
  .sidebar
    display none

aside
  border $border-default
  border-radius $border-radius
  margin-left $spacing-3
  width 370px
  &.bump-down
    margin-top 60px
  .search
    background-color $background-color
    border-bottom $border-default
    padding $spacing-2
  .post
    padding $spacing-4 $spacing-2
    .post-header
      h2
        margin-bottom $spacing-2
      p
        color $text-light
        font-size $text-smaller
        margin-bottom $spacing-4

    textarea
      height 150px

  .upload
    //padding $spacing
    width 100%

</style>
